import { ISetup } from "@smartrr/shared/entities/Organization";
import { SellingPlanGroupApiResponse } from "@smartrr/shared/entities/SellingPlanGroup";
import { NestedPath } from "@smartrr/shared/utils/setNestedProperty";
import { hasProductsSelected } from "./hasProductsSelected";

interface SetupUpdate { path: NestedPath<ISetup>; val: any }

export const buildSubscriptionSetupUpdates = (
  setup: ISetup,
  nextSellingPlanGroup: SellingPlanGroupApiResponse | undefined
): SetupUpdate[] => {
  if (!nextSellingPlanGroup?.shopifyId) {
    return [
      { path: "selectedSellingPlanId", val: "" },
      { path: "subscriptionSetup.sellingPlan", val: { date: null, completed: false, demo: false } },
      { path: "subscriptionSetup.product", val: { date: null, completed: false, demo: false } },
    ];
  }

  return [
    { path: "selectedSellingPlanId", val: nextSellingPlanGroup.shopifyId },
    {
      path: "subscriptionSetup.sellingPlan",
      val: {
        date: setup.subscriptionSetup.sellingPlan?.date ?? null,
        completed: true,
        demo: setup.subscriptionSetup.sellingPlan?.demo ?? false,
      },
    },
    {
      path: "subscriptionSetup.product",
      val: {
        date: setup.subscriptionSetup.product?.date ?? null,
        completed: hasProductsSelected(nextSellingPlanGroup),
        demo: setup.subscriptionSetup.product?.demo ?? false,
      },
    },
  ];
};
